export const tabsData = [
  {
    name: "Candidate Experience",
  },
  {
    name: "Anti-Cheat Features",
  },
  {
    name: "Launch Date",
  },
];



